import permissions from './permission-list'

export default [
  {
    path: '/collections',
    name: 'collections',
    component: () => import('@/views/collections/index.vue'),
    meta: {
      pageTitle: 'Daftar Koleksi',
      resource: permissions.collection,
      action: 'read',
      navActiveLink: 'collections',
      breadcrumb: [
        {
          text: 'Koleksi',
          active: true,
        },
      ],
    },
  },
  {
    path: '/collections/create',
    name: 'collections-create',
    component: () => import('@/views/collections/create.vue'),
    meta: {
      pageTitle: 'Daftar Collection',
      resource: permissions.collection,
      action: 'manage',
      navActiveLink: 'collections',
      breadcrumb: [
        {
          text: 'Collection',
          active: false,
          to: { path: '/collections' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/collections/:id/edit',
    name: 'collections-edit',
    component: () => import('@/views/collections/edit.vue'),
    meta: {
      pageTitle: 'Edit Koleksi',
      resource: permissions.collection,
      action: 'manage',
      navActiveLink: 'collections',
      breadcrumb: [
        {
          text: 'Koleksi',
          active: false,
          to: { path: '/collections' },
        },
        {
          text: 'Edit',
        },
      ],
    },
  },
]
